<template>
  <div>
    <div class="text-muted small">{{notification.created_at | formatRelativeDate}}</div>

    <!--CREATED-->
    <div>

      <div v-if="notification.data.media.collection_name === 'export_activity'">
        {{$t('system.your')}}
        {{$t('reports.activity_export')}}
        <span class="mr-3 ml-5 float-right text-muted cursor-pointer"
              @click="downloadMedia(notification.data.media)"
              qid="download-media"
        >
          <font-awesome-icon icon="cloud-download-alt" />
        </span>
        <a href="#" @click="downloadMedia(notification.data.media)" qid="create-p-media-item">
          {{ notification.data.media.file_name }}
        </a>
        {{$t('system.is_generated')}}.
      </div>

      <div v-if="notification.data.media.collection_name === 'export_process'">
        {{$t('system.your')}}
        {{$t('reports.process_export')}}
        <span class="mr-3 ml-5 float-right text-muted cursor-pointer"
              @click="downloadMedia(notification.data.media)"
              qid="download-media"
        >
          <font-awesome-icon icon="cloud-download-alt" />
        </span>
        <a href="#" @click="downloadMedia(notification.data.media)" qid="create-p-media-item">
          {{ notification.data.media.file_name }}
        </a>
        {{$t('system.is_generated')}}.
      </div>

      <div v-if="notification.data.media.collection_name === 'export_system'">
        {{$t('system.your')}}
        {{$t('reports.system_export')}}
        <span class="mr-3 ml-5 float-right text-muted cursor-pointer"
              @click="downloadMedia(notification.data.media)"
              qid="download-media"
        >
          <font-awesome-icon icon="cloud-download-alt" />
        </span>
        <a href="#" @click="downloadMedia(notification.data.media)" qid="create-p-media-item">
          {{ notification.data.media.file_name }}
        </a>
        {{$t('system.is_generated')}}.
      </div>

      <div v-if="notification.data.media.collection_name === 'export_third_party'">
        {{$t('system.your')}}
        {{$t('reports.third_party_export')}}
        <span class="mr-3 ml-5 float-right text-muted cursor-pointer"
              @click="downloadMedia(notification.data.media)"
              qid="download-media"
        >
          <font-awesome-icon icon="cloud-download-alt" />
        </span>
        <a href="#" @click="downloadMedia(notification.data.media)" qid="create-p-media-item">
          {{ notification.data.media.file_name }}
        </a>
        {{$t('system.is_generated')}}.
      </div>

    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'ReportGeneratedNotification',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
      }
    },
    components: {
      UserLink,
      Avatar
    },
    props: {
      notification: {},
      changes: false
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
